(function($){
    $(".close-form-message").click(function(){
        $(this).closest(".form__message").fadeOut();
    });

    $('.header__inline-menu').find('.mega-menu__list > li > ul').each(function() {
        var navLength = $(this).children().length;
        if(navLength > 13) {
            $(this).children().parent().parent().addClass('two-col');
        }
    });

    $('.header__inline-menu').find('.mega-menu__content > .mega-menu__list ').each(function() {
        var navListLength = $(this).children().length;
        if(navListLength === 1) {
            $(this).children().parent().addClass('one-col');
        } else if (navListLength === 2)  {
            $(this).children().parent().addClass('two-col');
        } else if (navListLength === 3)  {
            $(this).children().parent().addClass('three-col');
        } else if (navListLength === 4)  {
            $(this).children().parent().addClass('four-col');
        } else if (navListLength === 5)  {
            $(this).children().parent().addClass('five-col');
        } else {
            $(this).children().parent().addClass('hidden-col');
        }
    });

    $(".mega-menu").on({
        mouseenter: function () {
            $(this).addClass('hovered');
            $(this).attr('open', '');
        },
        mouseleave: function () {
            $(this).removeClass('hovered');
            $(this).removeAttr('open', '');
        }
    });

    $('body').on('click', '.mega-menu > .header__menu-item', function (e) {
        e.preventDefault();
        $('.mega-menu').removeClass('propped');
        $('.mega-menu').removeAttr('open', '');
        $(this).parent().addClass('propped');
        $(this).parent().attr('open', '');
    });

    $('body').on('click', '.mega-menu.propped > .header__menu-item', function (e) {
        e.preventDefault();
        $('.mega-menu').removeClass('propped');
        $('.mega-menu').removeAttr('open', '');
        $(this).parent().removeClass('propped');
        $(this).parent().removeAttr('open', '');
    });

    $('.mega-menu.hovered').mouseover(function(){
        $(this).parent().removeAttr('open', '');
    });

    $('body').on('mouseleave', '.mega-menu.propped', function () {
        $(this).attr('open', '');
    });

    if($('body').hasClass('template-customers-addresses')) {
        $('select').find('option').not('[value="United States"]').remove();
    }

    $(document).click(function() {
        var containerMenu = $(".mega-menu");
        if (!containerMenu.is(event.target) && !containerMenu.has(event.target).length) {
            $('.mega-menu').removeClass('propped');
            $('.mega-menu').removeAttr('open', '');
            $(this).removeClass('propped');
            $(this).removeAttr('open', '');
        }
    });

    if($('body').hasClass('template-collection') || $('body').hasClass('template-collection-specials')) {
        $('.js-load-more').on('click', function(){
            var $this =$(this),
                totalPages = parseInt($('[data-all-pages]').val()),
                currentPage = parseInt($('[data-this-page]').val()),
                datacollurl = $('[data-coll-url]').val();
            $this.addClass('processing');
            $this.next('[load-more-text]').addClass('hide');
            $this.next('[loader]').removeClass('hide');
            var nextUrl = $('[data-next-link]').val();
            var current_page_new = currentPage + 1;
            var next_coll = currentPage + 2;
            var gridItems = $('#product-grid').attr('data-product-count');
            var gridItemsInt = parseInt(gridItems);
            var totalItems = $('.info-load-more > .total').html();
            var currentTotalItems = $('.info-load-more > .current').html();
            var currentTotalItemsParsed = parseInt(currentTotalItems);
            $.ajax({
                url: nextUrl,
                type: 'GET',
                dataType: 'html',
                success: function(responseHTML){
                    $('[data-next-link]').val(datacollurl + "?page="+next_coll);
                    $('[data-this-page]').val(current_page_new);
                    $('#product-grid').append($(responseHTML).find('#product-grid').html());
                },
                complete: function() {
                    if(current_page_new < totalPages) {
                        $this.removeClass('processing');
                        $this.next('[load-more-text]').removeClass('hide');
                        $this.next('[loader]').addClass('hide');
                        var currentItems = (currentTotalItemsParsed + gridItemsInt);
                        $('.info-load-more > .current').text(currentItems);
                    }
                    if(current_page_new >= totalPages) {
                        $this.attr('disabled', 'disabled');
                        $this.next('[load-more-text]').text('Products Finished').removeClass('hide');
                        $this.next('[loader]').addClass('hide');
                        $('.info-load-more > .current').text(totalItems);
                    }
                }
            })
        });
    }

    $('body').on('click', 'div.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel', function () {
      $(this).toggleClass('kuExpand');
    });

    $(window).scroll(function(evt) {
      if ($(".shopify-section-header-sticky").hasClass("shopify-section-header-hidden")) {
        $('.cart__footer-wrapper').addClass('no-space');
      } else {
        $('.cart__footer-wrapper').removeClass('no-space');
      }
    });

})(jQuery);

var formHeight = $(".formWrap").height();
if(formHeight > 1200){
    console.log("test");
}
else {
console.log("test123");
}
